<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Abrir Modal</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">Esta seguro?</v-card-title>
        <v-card-text
          >Esta seguro que desea realizar esta accion blaa blaa
          blaa.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="green darken-1" flat @click="dialog = false"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
